module.exports = __webpack_public_path__ + "img/9.85663b8f.png";